import React, {useEffect} from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate} from 'react-router-dom';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import config from "../config";

//import {useDispatch} from 'react-redux';


//import {useDispatch} from 'react-redux';

const Login = () => {

  const apiBaseUrl = config.REACT_APP_API_BASE_URL;
  const [loginFailed, setLoginFailed] = React.useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (value) => {
  try {
    const { userId, password } = value;
    const res = await axios.post(`${apiBaseUrl}/api/users/login`, value);

    const token = res.data.token;
    const user_id = res.data.userId;
    const decoded = jwtDecode(token);

    localStorage.setItem('auth', JSON.stringify({ token, role: decoded.role }));
    localStorage.setItem('userId', JSON.stringify(user_id));
    localStorage.setItem('userId', decoded.userId);

    // session save ps
    sessionStorage.setItem("userPassword", password);

    navigate("/");
  } catch (error) {
    setLoginFailed(true);
    console.log(error);
  }
};


  //current log in user
  useEffect(() => {
    if (localStorage.getItem('auth')) {
      navigate('/');
    }
  }, [navigate]);

  return (
    <>
      <div className="pos-login-container">
        <div className="pos-login-main">
          <div className="pos-brand-section">
            <div className="pos-logo-wrapper">
              <img 
                src="mkfnblogo.png" 
                alt="MAKANFNB Logo" 
                className="pos-logo"
              />
            </div>
            <div className="pos-brand-text">
              <h1 className="pos-brand-title">MAKAN FNB</h1>
              <p className="pos-brand-subtitle">Point of Sale System</p>
            </div>
          </div>
          
          <div className="pos-login-panel">
            <div className="pos-panel-header">
              <h2>System Login</h2>
              <p>Enter your credentials to access POS</p>
            </div>
            
            <Form layout="vertical" onFinish={handleSubmit} className="pos-login-form">
              <Form.Item name="userId" label="User ID" className="pos-form-item">
                <Input 
                  className="pos-form-input" 
                  placeholder="Enter User ID"
                  size="large"
                />
              </Form.Item>
      
              <Form.Item name="password" label="Password" className="pos-form-item">
                <Input.Password 
                  className="pos-form-input" 
                  placeholder="Enter Password"
                  size="large"
                />
              </Form.Item>

              {loginFailed && (
                <Form.Item>
                  <div className="ant-form-item-explain ant-form-item-explain-connected">
                    {/* the text should be center */}
                    <div role="alert" className="ant-form-item-explain-error" style={{ textAlign: "center" }}>
                      <span style={{ display: "inline-block", width: "100%" }}>Incorrect Password/Email</span>
                    </div>
                  </div>
                </Form.Item>
              )}
      
              <Button 
                type="primary" 
                htmlType="submit" 
                className="pos-login-button"
                size="large"
                block
              >
                LOGIN
              </Button>
            </Form>
          </div>
        </div>
        
        <div className="pos-footer">
          <p>© {new Date().getFullYear()} MAKAN F&B POS System • Secure Login</p>
        </div>
      </div>

      <style>{`
        * {
          box-sizing: border-box;
        }

        .pos-login-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 20px;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          position: relative;
        }

        .pos-login-container::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="%23ffffff" stroke-width="0.5" opacity="0.05"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
          pointer-events: none;
        }

        .pos-login-main {
          background: rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(10px);
          border-radius: 16px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
          border: 1px solid rgba(255, 255, 255, 0.2);
          padding: 40px;
          width: 100%;
          max-width: 420px;
          position: relative;
          z-index: 1;
        }

        .pos-brand-section {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 32px;
          padding-bottom: 24px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        }

        .pos-logo-wrapper {
          background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
          padding: 12px;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);
        }

        .pos-logo {
          width: 48px;
          height: 48px;
          object-fit: contain;
          filter: brightness(0) invert(1);
        }

        .pos-brand-text {
          flex: 1;
        }

        .pos-brand-title {
          font-size: 24px;
          font-weight: 700;
          color: #ffffff;
          margin: 0;
          letter-spacing: -0.5px;
          text-transform: uppercase;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        }

        .pos-brand-subtitle {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.8);
          margin: 4px 0 0 0;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .pos-login-panel {
          background: rgba(255, 255, 255, 0);
          border-radius: 12px;
          padding: 24px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(5px);
        }

        .pos-panel-header {
          text-align: center;
          margin-bottom: 24px;
        }

        .pos-panel-header h2 {
          font-size: 20px;
          font-weight: 600;
          color: #ffffff;
          margin: 0 0 8px 0;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        }

        .pos-panel-header p {
          font-size: 13px;
          color: rgba(255, 255, 255, 0.8);
          margin: 0;
        }

        .pos-login-form .ant-form-item {
          margin-bottom: 20px;
        }

        .pos-login-form .ant-form-item-label > label {
          font-size: 12px;
          font-weight: 600;
          color: #ffffff;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        }

        .pos-form-input {
          border: 2px solid #d1d5db;
          border-radius: 8px;
          transition: all 0.2s ease;
          font-size: 14px;
          font-family: 'Courier New', monospace;
          font-weight: 500;
          background: #ffffff;
        }

        .pos-form-input:hover {
          border-color: #f97316;
        }

        .pos-form-input:focus,
        .pos-form-input.ant-input-focused {
          border-color: #f97316;
          box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
        }

        .pos-login-button {
          background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
          border: none;
          border-radius: 8px;
          font-weight: 700;
          font-size: 14px;
          height: 48px;
          margin-top: 16px;
          transition: all 0.2s ease;
          text-transform: uppercase;
          letter-spacing: 1px;
          box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);
        }

        .pos-login-button:hover {
          background: linear-gradient(135deg, #ea580c 0%, #dc2626 100%);
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(249, 115, 22, 0.4);
        }

        .pos-login-button:active {
          transform: translateY(0);
        }

        .pos-footer {
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          text-align: center;
          color: rgba(255, 255, 255, 0.6);
          font-size: 12px;
          z-index: 1;
        }

        .pos-footer p {
          margin: 0;
        }

        /* Responsive Design */
        @media (max-width: 480px) {
          .pos-login-container {
            padding: 16px;
          }

          .pos-login-main {
            padding: 24px;
            max-width: 100%;
          }

          .pos-brand-section {
            flex-direction: column;
            text-align: center;
            gap: 12px;
          }

          .pos-brand-title {
            font-size: 20px;
          }

          .pos-panel-header h2 {
            font-size: 18px;
          }
        }

        /* Override Ant Design styles */
        .ant-input-affix-wrapper {
          border: 2px solid #d1d5db;
          border-radius: 8px;
          background: #ffffff;
        }

        .ant-input-affix-wrapper:hover {
          border-color: #f97316;
        }

        .ant-input-affix-wrapper-focused {
          border-color: #f97316;
          box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
        }

        .ant-input-affix-wrapper .ant-input {
          font-family: 'Courier New', monospace;
          font-weight: 500;
        }

        .ant-btn-primary {
          background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
          border-color: transparent;
        }

        .ant-btn-primary:hover {
          background: linear-gradient(135deg, #ea580c 0%, #dc2626 100%);
          border-color: transparent;
        }

        .ant-message {
          z-index: 9999;
        }
      `}</style>
    </>
  );
};

export default Login;